import { ISignStrategy } from '@/sign/strategies/isign.strategy';
import { euSignService } from '@/sign/services/eusign.service';
import { SigningParams } from '@/sign/models/signing-params.model';
import { PrivateKeyType, SignMethod, SignPurpose } from '@/sign/models/sign-constants';
import { logger } from '@/helpers/log.service';

export abstract class SignPrivateKeyStrategy implements ISignStrategy {
  protected signMethod?: SignMethod;
  public signingParams: SigningParams = new SigningParams({});
  protected euSignLib: any;
  protected keyType: number = 0;
  protected signPurpose: SignPurpose = SignPurpose.None;
  protected mobileAppName?: string;

  protected constructor() {
    logger.debug(`[${this.constructor.name}] signMethod="${this.signMethod}" signPurpose=${SignPurpose[this.signPurpose]} mobileAppName="${this.mobileAppName}"`, this.signingParams);
  }

  public async execute(prms: SigningParams): Promise<any> {
    logger.debug(`[${this.constructor.name}:execute] prms`, prms);
    if (!prms) {
      throw new Error('Signing params is not defined');
    }
    this.signingParams = prms;
  }

  protected get privateKeyContext(): any {
    return this.signingParams.data?.privateKeyContext;
  }

  protected get isSeal(): boolean {
    return this.signingParams && this.signingParams.privateKeyType === PrivateKeyType.Seal;
  }

  protected getLibrary(): any {
    this.demandSignMethod();
    return euSignService.getLibrary(
      this.signMethod as SignMethod,
      this.signingParams.privateKeyType as PrivateKeyType,
      this.signingParams.signProvider,
      this.signingParams.keyReaderType);
  }

  protected async init(): Promise<void> {
    this.euSignLib = this.getLibrary();
  }

  protected async validate(): Promise<void> {
    if (!this.euSignLib) {
      throw new Error('EuSign library is not found');
    }
  }

  protected async getOwnCertificates(): Promise<any> {
    return this.euSignLib.CtxGetOwnCertificates(this.privateKeyContext);
  }

  protected async determineKeyTypes(): Promise<void> {
    const ownCertificates = await this.getOwnCertificates();
    if (ownCertificates && ownCertificates.length) {
      this.keyType = ownCertificates[0].infoEx.publicKeyType;
    }
  }

  private demandSignMethod(): void {
    if (!(this.signMethod as SignMethod)) {
      throw new Error('Sign method is not defined');
    }
  }
}
